module.exports = __webpack_public_path__ + "img/default-avatar.055a9197.png";